// src/components/JobOffers/Offers.js
import React, { useState } from "react";
import bg from "../../assets/bg.png";
import { CgHeadset } from "react-icons/cg";
import { FaRocket, FaMoneyBillWave, FaUserCheck } from "react-icons/fa";
import ApplyModal from "./ApplyModal.js";

const Offers = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <section
      className="bg-cover bg-center bg-no-repeat relative w-full min-h-full pt-20"
      style={{
        backgroundImage: `url(${bg})`,
        backgroundAttachment: "fixed",
      }}
    >
      <div className="min-h-screen flex items-start justify-center py-8 px-4">
        <div className="w-full max-w-6xl bg-white rounded-2xl border border-gray-200 shadow-lg overflow-hidden">
          <div className="relative bg-[#6a56f6] text-white text-center py-10 px-6 md:py-14 md:px-10">
            <div className="max-w-3xl mx-auto">
              <h1 className="text-lg md:text-xl lg:text-3xl font-bold leading-snug">
                🚀 Scholine recrute des Agents Commerciaux
                <br />
                <span className="block">Terrain (Algérie)</span>
              </h1>
              <p className="mt-4 text-blue-100 text-sm md:text-base">
                Rejoignez la révolution digitale des écoles privées algériennes.
              </p>
            </div>
          </div>

          <div className="relative z-10 -mt-4 px-6 md:px-12 pb-12">
            <div className="max-w-6xl mx-auto">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8">
                  <h2 className="text-lg font-bold text-gray-800 mb-3">
                    Qui sommes-nous ?
                  </h2>

                  <p className="text-gray-600 text-sm leading-relaxed">
                    Scholine est une plateforme digitale{" "}
                    <strong>100&nbsp;% algérienne</strong> conçue pour aider les
                    écoles privées à{" "}
                    <strong>centraliser la communication</strong>,
                    <strong> automatiser l’administratif</strong> et{" "}
                    <strong>simplifier le suivi pédagogique</strong>.
                  </p>

                  <p className="text-gray-600 text-sm leading-relaxed mt-3">
                    Notre mission&nbsp;: faire gagner du temps aux équipes,
                    améliorer la relation avec les parents et offrir une image
                    moderne de l’établissement — sans complexité technique.
                  </p>

                  <ul className="mt-4 text-gray-600 text-sm leading-relaxed list-disc pl-5 space-y-1">
                    <li>
                      Communication unifiée (notifications, messagerie,
                      annonces) en quelques clics.
                    </li>
                    <li>
                      Gestion scolaire&nbsp;: présences (QR &amp; manuel),
                      emplois du temps, notes, devoirs, cantine.
                    </li>
                    <li>
                      Comptes dédiés&nbsp;: <strong>Admin</strong>,{" "}
                      <strong>Enseignant</strong>, <strong>Parent</strong> et{" "}
                      <strong>Élève</strong> (applications mobiles incluses).
                    </li>
                    <li>
                      Tableaux de bord et rapports pour un pilotage clair et
                      rapide.
                    </li>
                    <li>
                      <strong>Formation &amp; support continus</strong> —{" "}
                      <em>mises à jour gratuites incluses</em>.
                    </li>
                  </ul>

                  <p className="text-gray-600 text-sm leading-relaxed mt-3">
                    Avec Scholine, vous passez d’outils dispersés (WhatsApp,
                    Excel, papiers) à<strong> une seule plateforme</strong>{" "}
                    simple et fiable, adaptée au contexte des écoles en Algérie.
                  </p>
                </div>

                <div className="md:col-span-2 bg-white rounded-2xl shadow-xl p-6 md:p-8">
                  <div className="space-y-6">
                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0">
                        <div className="h-10 w-10 rounded-full bg-blue-50 flex items-center justify-center">
                          <FaRocket className="text-[#6a56f6] text-lg" />
                        </div>
                      </div>
                      <div>
                        <h3 className="text-md font-bold text-gray-800">
                          Votre mission
                        </h3>
                        <ul className="mt-2 text-gray-600 text-sm leading-relaxed list-disc pl-5 space-y-1">
                          <li>
                            <strong>Prospecter et visiter</strong> les écoles
                            privées dans votre région.
                          </li>
                          <li>
                            <strong>Présenter</strong> la plateforme Scholine
                            (formation assurée).
                          </li>
                          <li>
                            <strong>Réaliser des démonstrations</strong>
                            simples auprès des directeurs.
                          </li>
                          <li>
                            <strong>Remonter</strong> les informations et
                            contacts chaque jour.
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0">
                        <div className="h-10 w-10 rounded-full bg-blue-50 flex items-center justify-center">
                          <FaMoneyBillWave className="text-[#6a56f6] text-lg" />
                        </div>
                      </div>
                      <div>
                        <h3 className="text-md font-bold text-gray-800">
                          Rémunération motivante
                        </h3>

                        <ul className="text-gray-600 text-sm leading-relaxed mt-2 list-disc pl-5 space-y-1">
                          <li>
                            Commission jusqu’à <strong>15&nbsp;%</strong> sur
                            chaque contrat signé.
                          </li>
                          <li>
                            <strong>Prime de fidélité</strong> si l’école
                            renouvelle son abonnement.
                          </li>
                          <li>
                            <strong>Bonus palier</strong> (ex. 3 signatures/mois
                            → prime supplémentaire).
                          </li>
                          <li>
                            <strong>Évolution</strong> possible vers responsable
                            régional selon résultats.
                          </li>
                          <li>
                            <strong>Indemnité</strong> de déplacement possible
                            selon missions + commission.
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0">
                        <div className="h-10 w-10 rounded-full bg-blue-50 flex items-center justify-center">
                          <FaUserCheck className="text-[#6a56f6] text-lg" />
                        </div>
                      </div>
                      <div>
                        <h3 className="text-md font-bold text-gray-800">
                          Profil recherché
                        </h3>

                        <ul className="text-gray-600 text-sm leading-relaxed mt-2 list-disc pl-5 space-y-1">
                          <li>
                            Ancien(ne) <strong>enseignant(e)</strong> ou
                            intervenant pédagogique.
                          </li>
                          <li>
                            <strong>Secrétaire</strong> d’établissement /{" "}
                            <strong>administration scolaire</strong>.
                          </li>
                          <li>
                            <strong>Responsable</strong> ou{" "}
                            <strong>gestionnaire</strong> de centre éducatif /
                            privé.
                          </li>
                          <li>
                            <strong>Professeur particulier</strong> / soutien
                            scolaire avec réseau d’écoles.
                          </li>
                          <li>
                            <strong>Conseiller(ère)</strong> d’orientation / vie
                            scolaire / surveillant(e) principal(e).
                          </li>
                          <li>
                            <strong>Commercial(e) terrain</strong> ayant déjà
                            travaillé avec des écoles.
                          </li>
                          <li>
                            <strong>
                              Jeune diplômé(e) en commerce/marketing
                            </strong>
                            motivé(e) par le terrain.
                          </li>
                          <li>
                            À l’aise à l’oral, excellent relationnel,
                            présentation soignée.
                          </li>
                          <li>
                            Motivation forte pour atteindre les objectifs ;
                            moyen de déplacement souhaité.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-8 bg-blue-50 border border-blue-100 rounded-xl py-6 px-6 flex items-center justify-center gap-1 text-center">
                <div className="h-12 w-12 rounded-full flex items-center justify-center shadow-sm flex-shrink-0">
                  <CgHeadset className="text-[#6a56f6] text-2xl" />
                </div>

                <div className="text-left max-w-md">
                  <h4 className="text-black font-bold text-base md:text-lg">
                    Formation et support commercial fournis
                  </h4>
                  <p className="text-[#6a56f6] text-sm mt-1">
                    Vous serez accompagné à chaque étape pour assurer votre
                    succès.
                  </p>
                </div>
              </div>

              <div className="mt-10 text-center">
                <button
                  onClick={handleOpenModal}
                  className="inline-block bg-[#6a56f6] hover:bg-[#5a46e0] text-white font-semibold px-8 py-3 rounded-full shadow-md transition"
                >
                  Postuler maintenant
                </button>

                <p className="mt-4 text-gray-500 text-sm">
                  Ou contactez-nous directement :{" "}
                  <a
                    href="mailto:sales@scholine.com"
                    className="text-[#6a56f6] font-medium"
                  >
                    admin@sefasoft.com
                  </a>
                </p>
              </div>
            </div>
          </div>

          <footer className="border-t border-gray-100 text-center text-sm text-gray-400 py-4">
            © 2025 Scholine. Tous droits réservés.
          </footer>
        </div>
      </div>

      {isModalOpen && <ApplyModal onClose={handleCloseModal} />}
    </section>
  );
};

export default Offers;
